module.exports = __webpack_public_path__ + "static/media/bengaluru-map1.4c0b85b8.png";